import { Component, AfterViewInit, OnInit, Signal } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";
import { AuthService } from "./auth/auth.service";
import { SpinnerService } from "./shared/services/spinner.service";
import { UrlService } from "./shared/services/url.service";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    standalone: false
})
export class AppComponent implements OnInit, AfterViewInit {
  showLoading: Signal<boolean>;
  previousUrl: string = null;
  currentUrl: string = null;

  constructor(
    private spinnerService: SpinnerService,
    private authService: AuthService,
    private router: Router,
    private urlService: UrlService
  ) {
    this.showLoading = toSignal(this.spinnerService.showLoading$, { initialValue: false });
  }

  ngOnInit() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
        this.urlService.setPreviousUrl(this.previousUrl);
      });
  }

  ngAfterViewInit() {
    this.spinnerService.init();
  }

  loginExpired() {
    this.authService.logout();
  }
}
